// extracted by mini-css-extract-plugin
export default {"review-reasons":"review-reasons","heading-txt":"heading-txt","reason-holder":"reason-holder"};